import React from "react";

class Cars extends React.Component {
    render() {
        return <h1>cars page</h1>;
    }
}
export default Cars;
